/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export type ApplePayBridgeContext = 'pdp' | 'cart' | 'checkout';

const CONTROLLER_NAME = 'ApplePayBridge-Button';

export function buildApplePayBridgeUrl(siteId: string, localeId: string, context: ApplePayBridgeContext, sku?: string) {
    const storefrontLocale = localeId.replaceAll('-', '_');
    const base = `/on/demandware.store/Sites-${encodeURIComponent(siteId)}-Site/${encodeURIComponent(storefrontLocale)}/${CONTROLLER_NAME}`;
    const query = new URLSearchParams({ context });
    if (context === 'pdp' && sku) query.set('sku', sku);
    return `${base}?${query.toString()}`;
}

export function completedOrderNumber(value: string, storefrontOrigin: string): string | null {
    try {
        const url = new URL(value, storefrontOrigin);
        if (url.origin !== storefrontOrigin) return null;
        const routeName = url.pathname.split('/').pop();
        if (routeName !== 'COPlaceOrder-Submit' && routeName !== 'COPlaceOrder-SubmitOrderConformation') {
            return null;
        }
        const orderNo = url.searchParams.get('order_id') || url.searchParams.get('ID');
        return orderNo && /^[A-Za-z0-9_-]{1,64}$/.test(orderNo) ? orderNo : null;
    } catch {
        return null;
    }
}
